import React from 'react';
import { oneOf, func } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { I18n } from '@fiverr-private/i18n-react';
import { Link, Typography } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { LoginLink } from '../../../../shared/LoginLink';
import { ERROR_CODE } from '../../../services/affiliate';

export const ErrorMessage = withRouter((props) => {
    const { reason, history, onBack = Function.prototype } = props;

    const loginLink = (text) => <LoginLink>{text}</LoginLink>;

    const backLink = (text) => {
        const onLinkClick = () => {
            onBack();

            // Due to limitation of blocking users to go back
            // there is no back state saved - need manually pick route.
            // @TODO - might be fixed with a navigator provider
            // generic for all navigations.
            history.replace('/');
        };

        return (
            <Link onClick={onLinkClick} color="red_700" decoration="underline" cursor="pointer" role="link">
                {text}
            </Link>
        );
    };

    const clientError = () => {
        const templates = {
            refresh: (text) => {
                const refresh = () => {
                    location.reload();
                };

                return (
                    <Link onClick={refresh} color="red_700" decoration="underline" cursor="pointer" role="link">
                        {text}
                    </Link>
                );
            },
        };

        return <I18n templates={templates} k="affiliates_signup_perseus.errors.client_error" />;
    };

    const emailTaken = () => {
        const templates = {
            login: loginLink,
            back: backLink,
        };

        return <I18n templates={templates} k="affiliates_signup_perseus.errors.email_taken" />;
    };

    const usernameTaken = () => {
        const templates = {
            login: loginLink,
            back: backLink,
        };

        return <I18n templates={templates} k="affiliates_signup_perseus.errors.username_taken" />;
    };

    const serviceError = () => <I18n k="affiliates_signup_perseus.errors.service_error" />;

    const telegramInvalid = () => {
        const templates = {
            back: backLink,
        };

        return <I18n templates={templates} k="affiliates_signup_perseus.errors.telegram_invalid" />;
    };

    const MESSAGES = {
        [ERROR_CODE.FORBIDDEN]: clientError,
        [ERROR_CODE.CLIENT_ERROR]: clientError,
        [ERROR_CODE.EMAIL_TAKEN]: emailTaken,
        [ERROR_CODE.SERVICE_ERROR]: serviceError,
        [ERROR_CODE.NOT_FOUND]: serviceError,
        [ERROR_CODE.CX_EMAIL_TAKEN]: emailTaken,
        [ERROR_CODE.CX_USERNAME_TAKEN]: usernameTaken,
        [ERROR_CODE.CX_UNKNOWN_ERROR]: clientError,
        [ERROR_CODE.CX_UNAVAILABLE]: serviceError,
        [ERROR_CODE.CX_TELEGRAM_INVALID]: telegramInvalid,
    };

    return (
        <Stack role="alert" paddingLeft="2">
            <Typography color="red_700">{MESSAGES[reason]()}</Typography>
        </Stack>
    );
});

ErrorMessage.propTypes = {
    reason: oneOf(Object.values(ERROR_CODE)),
    onBack: func,
};
